const EPSILON = 0.0005;

// deg => rad
export function degToRads(deg: number): number {
  return (deg * Math.PI) / 180;
}

// approximate equality, similar to vitest.isCl
export function isCloseTo(a: number, b: number): boolean {
  return Math.abs(a - b) < EPSILON;
}

//
// for css
//

// css degrees
export function deg(x: number): string {
  return `${Math.round(x)}deg`;
}

// css px
export function px(x: number): string {
  return `${Math.round(x)}px`;
}

// css width/height in px
export function pxSize(w: number, h: number): string {
  return `width: ${px(w)}; height: ${px(h)};`;
}
